
import { Ingredient, Product, MenuConfig, CategoryConfig, OrderModesSettings, LoyaltySettings, ServingOption, SoundSettings, FiscalPrinterSettings } from "./types";

export const DEFAULT_TAKE_AWAY_FEE = 0.20;
export const DEFAULT_DISPOSABLE_FEE = 0.20; 

export const DEFAULT_ORDER_MODES: OrderModesSettings = {
  dineIn: { label: "Mangia Qui", isActive: true },
  takeAway: { label: "Porto Via", isActive: true },
  delivery: { label: "Consegna a Domicilio", isActive: true }
};

export const DEFAULT_SERVING_OPTIONS: ServingOption[] = [
    { id: 'plate', label: 'Al Piatto', price: 0, isDefault: true, isActive: true },
    { id: 'disposable', label: 'Monouso / Box', price: 0.20, isActive: true }
];

export const DEFAULT_SOUND_SETTINGS: SoundSettings = {
  enabled: true,
  volume: 0.5,
  soundType: 'doorbell'
};

export const DEFAULT_FISCAL_PRINTER_SETTINGS: FiscalPrinterSettings = {
  isEnabled: false,
  ipAddress: '',
  port: '80',
  brand: 'EPSON',
  protocol: 'XML',
  departmentMapping: {
    default: 1,
    food: 1,
    beverage: 2,
    alcohol: 3
  },
  enableLottery: false
};

// NEW: Default Loyalty Settings
export const DEFAULT_LOYALTY_SETTINGS: LoyaltySettings = {
  isEnabled: false,
  programType: 'ORDER', // Default to points per order
  pointsPerOrder: 1,
  euroPerPoint: 10,     // Default 1 point every 10 euro
  pointsToRedeem: 10,
  redemptionValue: 5.00, // €
  customTitle: "",       // Default empty (shows price)
  customDescription: "" // Default empty
};

// EU STANDARD ALLERGENS LIST
export const ALLERGENS_LIST = [
    { id: 'GLUTEN', label: 'Glutine', icon: '🌾' },
    { id: 'MILK', label: 'Latte', icon: '🥛' },
    { id: 'EGGS', label: 'Uova', icon: '🥚' },
    { id: 'NUTS', label: 'Frutta Guscio', icon: '🌰' },
    { id: 'PEANUTS', label: 'Arachidi', icon: '🥜' },
    { id: 'FISH', label: 'Pesce', icon: '🐟' },
    { id: 'CRUSTACEANS', label: 'Crostacei', icon: '🦀' },
    { id: 'MOLLUSCS', label: 'Molluschi', icon: '🐙' },
    { id: 'SOY', label: 'Soia', icon: '🌱' },
    { id: 'CELERY', label: 'Sedano', icon: '🥬' },
    { id: 'MUSTARD', label: 'Senape', icon: '🌭' },
    { id: 'SESAME', label: 'Sesamo', icon: '🍘' },
    { id: 'SULPHITES', label: 'Solfiti', icon: '🍷' },
    { id: 'LUPIN', label: 'Lupini', icon: '🌼' }
];

export const MENU_PARSER_SYSTEM_PROMPT = `
Sei un esperto AI incaricato di digitalizzare menu fisici di ristoranti per un'app di delivery.
Il tuo compito è analizzare le immagini fornite, comprendere la struttura logica del menu e restituire un JSON COMPLETO che includa Menu, Categorie, Prodotti e INGREDIENTI (Aggiunte).

ISTRUZIONI DI STRUTTURAZIONE (FONDAMENTALI):
Devi separare nettamente le sezioni principali del menu in entità "Menu" diverse.
NON creare un unico menu gigante. 

Gerarchia:
1. MENU (Macro-Aree): Es. "Pizzeria", "Ristorante", "Bevande", "Dolci", "Vini". 
2. CATEGORIE (Sezioni interne ai Menu): Es. dentro Pizzeria -> "Rosse", "Bianche". Dentro Ristorante -> "Antipasti", "Primi".
3. PRODOTTI: I singoli piatti.
4. INGREDIENTI (Extra/Aggiunte): Se trovi liste di ingredienti aggiuntivi, supplementi o variazioni con prezzo (es. "Aggiunta Mozzarella +1€", "Supplemento Patatine +2€").

REGOLE DI RAGGRUPPAMENTO (IMPORTANTE):
- Se nel testo vedi "Pizze", crea un menu con ID "PIZZERIA".
- Se vedi "Primi", "Secondi", "Antipasti", crea un menu con ID "FOOD" o "RISTORANTE".
- Se vedi "Bevande", "Birre", "Vini", crea un menu separato con ID "DRINKS".
- Se vedi "Dolci" o "Dessert", crea un menu separato con ID "DESSERT".
- Ogni prodotto DEVE avere 'menuId' corrispondente al menu in cui si trova.

ESTRAZIONE INGREDIENTI (CRUCIALE):
- Cerca sezioni come "Aggiunte", "Supplementi", "Ingredienti Extra", "Variazioni".
- Estrai ogni singola voce come un oggetto nell'array "ingredients".
- Se non c'è una categoria esplicita per l'ingrediente, usa "Extra" o "Aggiunte".

OUTPUT JSON ATTESO (RISPETTA LO SCHEMA):
{
  "menus": [
    { "id": "FOOD", "name": "Cucina", "title": "La Nostra Cucina", "order": 1 },
    { "id": "DRINKS", "name": "Bevande", "title": "Le Nostre Bevande", "order": 2 }
  ],
  "categories": [
    { "id": "STARTERS", "name": "Antipasti", "menuId": "FOOD", "order": 1 },
    { "id": "BEERS", "name": "Birre", "menuId": "DRINKS", "order": 1 }
  ],
  "products": [
    { 
      "name": "Bruschetta", 
      "categoryId": "STARTERS", 
      "menuId": "FOOD", 
      "basePrice": 5.0, 
      "description": "Pane tostato con pomodoro", 
      "isActive": true,
      "allergens": ["GLUTEN"]
    }
  ],
  "ingredients": [
    {
      "name": "Mozzarella Extra",
      "category": "Aggiunte",
      "extraPrice": 1.50,
      "allergens": ["MILK"]
    },
    {
      "name": "Patatine Fritte",
      "category": "Contorni",
      "extraPrice": 3.00,
      "allergens": []
    }
  ]
}

ESTRAZIONE ALLERGENI (IMPORTANTE):
Cerca di indovinare o leggere dal menu gli allergeni presenti sia nei PRODOTTI che negli INGREDIENTI. Usa SOLO questi ID esatti in un array di stringhe "allergens":
'GLUTEN' (Glutine), 'MILK' (Latte), 'EGGS' (Uova), 'NUTS' (Frutta a guscio), 'PEANUTS' (Arachidi), 'FISH' (Pesce), 'CRUSTACEANS' (Crostacei), 'MOLLUSCS' (Molluschi), 'SOY' (Soia), 'CELERY' (Sedano), 'MUSTARD' (Senape), 'SESAME' (Sesamo), 'SULPHITES' (Solfiti), 'LUPIN' (Lupini).

Se l'immagine è di un negozio RETAIL (non cibo), adatta le categorie (es. Menu UOMO, Menu DONNA) e lascia gli allergeni vuoti.
`;

const stringToColor = (str: string) => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  const c = (hash & 0x00ffffff).toString(16).toUpperCase();
  return "00000".substring(0, 6 - c.length) + c;
};

export const getDefaultImage = (name: string) => {
  if (!name) return "https://ui-avatars.com/api/?name=80&background=000&color=fff";
  const cleanName = name.trim();
  const bg = stringToColor(cleanName);
  return `https://ui-avatars.com/api/?name=${encodeURIComponent(cleanName)}&background=${bg}&color=fff&size=512&font-size=0.4&bold=true&length=2`;
};

export const INITIAL_MENUS: MenuConfig[] = [
  { 
    id: 'SWEET', 
    name: 'Dolce', 
    title: 'Dolce Tentazione 🥞', 
    imageUrl: 'https://images.unsplash.com/photo-1519340333755-56e9c1d04579?auto=format&fit=crop&q=80',
    order: 1,
    isActive: true,
    availableForDelivery: true
  },
  { 
    id: 'SALTY', 
    name: 'Salato', 
    title: 'Sfizio Salato 🥓', 
    imageUrl: 'https://images.unsplash.com/photo-1550547660-d9450f859349?auto=format&fit=crop&q=80',
    order: 2,
    isActive: true,
    availableForDelivery: true
  }
];

export const INITIAL_CATEGORIES: CategoryConfig[] = [
  { id: 'CURED_MEAT', name: 'Affettati', menuIds: ['SALTY'], order: 1 },
  { id: 'CHEESE', name: 'Formaggi', menuIds: ['SALTY'], order: 2 },
  { id: 'VEGETABLE', name: 'Verdure', menuIds: ['SALTY'], order: 3 },
  { id: 'SAUCE_SALTY', name: 'Salse', menuIds: ['SALTY'], order: 4 },
  { id: 'CREAM', name: 'Creme', menuIds: ['SWEET'], order: 5 },
  { id: 'FRUIT', name: 'Frutta', menuIds: ['SWEET'], order: 6 },
  { id: 'CRUNCH', name: 'Granelle', menuIds: ['SWEET'], order: 7 },
  { id: 'SNACK', name: 'Snack', menuIds: ['SWEET'], order: 8 },
  { id: 'SAUCE_SWEET', name: 'Salse Dolci', menuIds: ['SWEET'], order: 9 }
];

export const INITIAL_PRODUCTS: Product[] = [];
export const INITIAL_INGREDIENTS: Ingredient[] = [];

// CITY PROXIMITY MAPPING
export const NEARBY_CITIES: Record<string, string[]> = {
    'pescara': ['montesilvano', 'spoltore', 'francavilla al mare', 'chieti', 'città sant\'angelo', 'silvi', 'cepagatti'],
    'milano': ['sesto san giovanni', 'cinisello balsamo', 'rho', 'cologno monzese', 'paderno dugnano', 'rozzano', 'corsico', 'segrate'],
    'roma': ['fiumicino', 'ciampino', 'tivoli', 'pomezia', 'anzio', 'nettuno', 'guidonia'],
    'torino': ['moncalieri', 'rivoli', 'collegno', 'venaria reale', 'grugliasco', 'settimo torinese'],
    'napoli': ['casoria', 'casavatore', 'portici', 'ercolano', 'torre del greco', 'pozzuoli'],
    'bologna': ['casalecchio di reno', 'san lazzaro di savena', 'castel maggiore', 'zola predosa'],
    'firenze': ['scandicci', 'sesto fiorentino', 'campi bisenzio', 'bagno a ripoli'],
    'bari': ['modugno', 'triggiano', 'bitritto', 'capurso', 'valenzano'],
    'palermo': ['bagheria', 'monreale', 'villabate', 'carini'],
    'catania': ['misterbianco', 'gravina di catania', 'mascalucia', 'tremestieri etneo']
};

export const isNearbyCity = (city1: string, city2: string) => {
    if (!city1 || !city2) return false;
    
    // Split by comma and clean up whitespace
    const c1List = city1.split(',').map(c => c.toLowerCase().trim()).filter(Boolean);
    const c2List = city2.split(',').map(c => c.toLowerCase().trim()).filter(Boolean);
    
    // Check if any city in list 1 matches or is nearby any city in list 2
    for (const c1 of c1List) {
        for (const c2 of c2List) {
            if (c1 === c2) return true;
            if (c1.includes(c2) || c2.includes(c1)) return true;
            
            const nearby1 = NEARBY_CITIES[c1] || [];
            const nearby2 = NEARBY_CITIES[c2] || [];
            
            if (nearby1.includes(c2) || nearby2.includes(c1)) return true;
            
            if (nearby1.some(nc => c2.includes(nc) || nc.includes(c2))) return true;
            if (nearby2.some(nc => c1.includes(nc) || nc.includes(c1))) return true;
        }
    }
    
    return false;
};
